import React, { useEffect, useState } from 'react';
import JobModificationTable from './components/modificationTable';
import { Modification } from 'src/types/modification';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import ModificationService from './service/modificationService';
import LoadingSpinner from 'src/components/shared/loadingSpinner/loadingSpinner';
import JobModificationModal from './components/modificationModal';
import TopOptions from './components/topOptions';
import { useAppDispatch } from 'src/store/store';
import { createToast } from 'src/store/toastsSlice';
import { getModifications } from '../../../../store/modificationsSlice';
import { TOAST_TIMEOUT } from 'src/config/Toast';

const JobModificationConfig = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [selectedModification, setSelectedModification] = useState<Modification | null>(null);
  const [searchField, setSearchField] = useState('');

  useEffect(() => {
    dispatch(getModifications())
      .unwrap()
      .finally(() => setIsLoading(false));
  }, []);

  const onSave = async (payload: Modification) => {
    const { name } = await ModificationService.createOrupdateModifications(payload);
    setIsCreateModalOpen(false);
    setSearchField(name);
    setSelectedModification(null);
    await dispatch(getModifications()).unwrap();
    dispatch(
      createToast({
        type: 'success',
        message: 'Saved modification successfully',
        timeout: TOAST_TIMEOUT,
      }),
    );
  };

  const onCancel = () => {
    setIsCreateModalOpen(false);
    setSelectedModification(null);
  };

  const onEdit = (row: Modification) => {
    setSelectedModification(row);
    setIsCreateModalOpen(true);
  };

  return (
    <div>
      <Row spacingInset={'400 400 500 none'}>
        <Text alignment="center">Here you can view and modify the list of task modifications within RTW</Text>
      </Row>
      {!isLoading ? (
        <>
          <JobModificationModal
            selectedModification={selectedModification}
            isOpen={isCreateModalOpen}
            onSave={onSave}
            onCancel={onCancel}
          />
          <TopOptions
            onOpen={() => setIsCreateModalOpen(true)}
            searchField={searchField}
            setSearchField={setSearchField}
          />
          <JobModificationTable onEdit={(row) => onEdit(row!)} searchField={searchField} />
        </>
      ) : (
        <LoadingSpinner />
      )}
    </div>
  );
};

export default JobModificationConfig;
